import React from "react";
import { Badge } from "react-bootstrap";

import { GamePublicationState, GamePublicationWishlistState, useChoiceLabel } from "@/const";

export function GamePublicationStateDisplay({ state }) {
    const GamePublicationStateTrans = useChoiceLabel("GamePublicationState");
    switch (state) {
        case GamePublicationState.CONFIGURATION:
            return <Badge variant="light">{GamePublicationStateTrans[state]}</Badge>;
        case GamePublicationState.CONFIGURATION_MARKETING:
            return <Badge variant="light">{GamePublicationStateTrans[state]}</Badge>;
        case GamePublicationState.TESTING:
            return <Badge variant="warning">{GamePublicationStateTrans[state]}</Badge>;
        case GamePublicationState.TESTING_MARKETING:
            return <Badge variant="warning">{GamePublicationStateTrans[state]}</Badge>;
        case GamePublicationState.DONE:
            return <Badge variant="success">{GamePublicationStateTrans[state]}</Badge>;
        case GamePublicationState.UNPUBLISH_REQUEST:
            return <Badge variant="danger">{GamePublicationStateTrans[state]}</Badge>;
        case GamePublicationState.UNPUBLISHED:
            return <Badge variant="danger">{GamePublicationStateTrans[state]}</Badge>;
        default:
            return null;
    }
}

export function GamePublicationWishlistStateDisplay({ state }) {
    const GamePublicationWishlistStateTrans = useChoiceLabel("GamePublicationWishlistState");
    switch (state) {
        case GamePublicationWishlistState.CONFIGURATION:
            return <Badge variant="light">{GamePublicationWishlistStateTrans[state]}</Badge>;
        case GamePublicationWishlistState.CONFIGURATION_MARKETING:
            return <Badge variant="light">{GamePublicationWishlistStateTrans[state]}</Badge>;
        case GamePublicationWishlistState.TESTING_MARKETING:
            return <Badge variant="warning">{GamePublicationWishlistStateTrans[state]}</Badge>;
        case GamePublicationWishlistState.DONE:
            return <Badge variant="success">{GamePublicationWishlistStateTrans[state]}</Badge>;
        default:
            return null;
    }
}
